import utils from "../../../utils/utils";
import {authenticationService} from "../../../services/AuthenticationService";
import SvGraphics from "../../../assets/SvGraphics";
import React from "react";
import {renderToString} from 'react-dom/server'
import {OverlayTrigger} from "react-bootstrap";

const moment = require("moment");

export class VisitSummaryPDF {

    params

    constructor(params) {
        this.params = params
    }


    getSummaryFooter() {
        let phoneSVG = renderToString(<SvGraphics className={'white-svg'} svgname={'phone-icon'} width={'14px'}
                                                  min-height={'14px'}/>)
        let mailSVG = renderToString(<SvGraphics className={'white-svg'} svgname={'email-icon'} width={'14px'}
                                                 min-height={'14px'}/>)
        let asayaSVG = renderToString(<SvGraphics className={'white-svg2'} svgname={'asaya_pdf'} width={'125px'}
                                                  min-height={'38px'}/>)



        let footer = (
            '<div dir="rtl" class="footer_block">' +
            '<div dir="rtl" class="footer_item1">' +
            '<div dir="rtl" class="footer_item_sentence">מרכז תמיכת מטופלים</div>' +
            '<div dir="rtl" class="svg-sentence">' +
            `${phoneSVG}` +
            '<div dir="rtl" class="footer_item_sentence2">073-3807977</div>' +
            '</div>' +
            '</div>' +
            '<div dir="rtl" class="footer_item2">' +
            '<div dir="rtl" class="footer_item_sentence">שאלות? נשמח לעזור</div>' +
            '<div dir="rtl" class="svg-sentence">' +
            `${mailSVG}` +
            '<div dir="rtl" class="footer_item_sentence2">acc@sade.group</div>' +
            '</div>' +
            '</div>' +
            '<div dir="rtl" class="footer_item3">' +
            '<div dir="rtl" class="footer_item_sentence_bold">מרכז אסייא למטופלים</div>' +
            '<div dir="rtl" class="footer_item_sentence_bold">PATIENT SUPPORT PROGRAM</div>' +
            '</div>' +
            '<div dir="rtl" class="footer_item4">' +
            `${asayaSVG}` +
            '</div>' +

            '</div>'
        )
        let currentUserProfile = authenticationService.currentUserValue.profile;
        let clinicName = currentUserProfile.Doctor?.Clinic?.Clinic_Name ? currentUserProfile.Doctor.Clinic.Clinic_Name : ""

        return this.params.cannabis_patient && (!clinicName.includes("נטע")) ? footer : ""
    }

    getInstructions() {
        let instruction = (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-title-block">' +
            '<div dir="rtl" class="pdfFile-details-title-label">הנחיות כלליות למטופלי קנביס</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">הוסבר למטופל/ת בפירוט על הנושאים הבאים:</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-Block">' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הסכנות הפוטנציאליות משימוש בקנביס רפואי הכוללות:</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">פגיעה קוגניטיבית, כפגיעה בזיכרון ובהליכי חשיבה</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">בשימוש לטווח ארוך נמצאו חדרי מוח מורחבים ביחס לגיל, דבר המעיד על אטרופיה מוחית עם פגיעה בחומר הלבן והאפור</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">סכנה להתמכרות גופנית ו/או נפשית וכי הגמילה אינה קלה בחלק מהמקרים, ומלווה בסבל גופני ונפשי</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">פגיעה בפריון, עקב פגיעה בקליטת העובר בנשים, ופגיעה באיכות הזרע בגברים</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הגברת סיכון לגידולים סרטנים שונים</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">ירידה בגובה ובמשקל בצריכה בגיל צעיר</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">בצריכה בעת הריון, ירידה בגובה ובמשקל בתינוק וירידה בכמות החומר האפור במוח דבר העלול לגרור פיגור שכלי</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הגברת סיכון לאירועים טרומבואמבוליים ולאירועים מוחיים עם פגיעה נוירולוגית קשה עד מוות</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-subpoint"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הגברת סיכון לאירועים מוחיים </div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הוסבר כי הרשימה מעל היא חלקית וכי יש מידע בספרות על פגיעות נוספות גופניות, נפשיות וחברתיות</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">או משרד הבריאות הישראלי הוסבר FDA EMEA הוסבר כי אין אישור לכך כי הקנביס היא תרופה מאושרת. על ידי רשויות\n' +
            'הבריאותכי אין אנו יודעים מה משמעות השימוש לטווח ארוך</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">לנשים בגיל פריון הוסבר כי יש להפסיק קנביס במידה ונכנסות להיריון ולדווח לרופא המטפל ולגניקולוג העוקב אחר ההיריון</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הוסבר לגבי איסור על נהיגה ושמירה של הקנביס לשימוש עצמי בלבד</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הוסבר כי עליו/ה להמשיך במעקב במרפאת הכאב  ומעקב פסיכולוגי במידת הנדרש</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">הוסבר כי אין הרופא אחראי על טיב ואספקת הקנביס אלא משרד הבריאות</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">הרופא והמרפאה יכולים בכל שלב להפסיק את הרישיון על פי שיקול דעתם בלבד. במקרה כזה יהיה באחריות\n' +
            ' החולה למצוא רופא שיחדש את רישיונו. כל הפרה של תנאי הרישיון כמו חוסר עמידה במעקבים ובהבאת האישורים\n' +
            '.הרלוונטיים ועוד, הם סיבה להפסקת חידושי הרישיונות</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence3">הומלץ למטופל/ת לבחור בצורת צריכה שאינה עישון (אידוי, שמן וכו\'), עקב סכנה לנזקים ריאתיים משמעותיים מהעישון והחשיפה לחומרים בקנביס. הסיכון עולה לדלקות גרון, דלקות סימפונות, דלקות וזיהומי מערכת הנשימה העליונה, התפתחות כרונית של אסטמה ואמפיזמה (גנחת ונפחת) וסרטן ריאות</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">במידה ולא תושג יעילות יש ליצור קשר עם המרפאה לצורך העלאת מינון/שינוי טיפול</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">במידה ויש תופעות לוואי קלות ניתן לרדת במינון ולהמשיך במינון נמוך יותר</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence2">במידה ויש תופעות לוואי חזקות יותר, להפסיק נטילה ולפנות לרופא המשפחה או למיון תוך כדי התייעצות עם הדרכה ופניה\n' +
            'חוזרת אל המרפאה</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-Instruction-items">' +
            '<div dir="rtl" class="pdfFile-Instruction-point"></div>' +
            '<div dir="rtl" class="pdfFile-Instruction-sentence">יש להמשיך בכל המעקבים הרפואיים השגרתיים</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>'
        )
        let currentUserProfile = authenticationService.currentUserValue.profile;
        let clinicName = currentUserProfile.Doctor?.Clinic?.Clinic_Name ? currentUserProfile.Doctor.Clinic.Clinic_Name : ""

        return this.params.cannabis_patient && (!clinicName.includes("נטע")) ? instruction : ""
    }

    getPatientAge() {
        if (this.params.Date_of_birth !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = this.params.Date_of_birth ? this.params.Date_of_birth.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }


    getInsurace(insuranceID){
        switch (insuranceID) {
            case "1": return "מכבי"
            case "2": return "כללית"
            case "3": return "לאומית"
            case "4": return "מאוחדת"
            case "5": return "חברת ביטוח"
            case "6": return "צה\"ל"
            case "7": return "משרד הביטחון"
            case "8": return "ללא ביטוח"
            case "9": return "רשות פלסטינאית"
            case "10": return "אחר"
            default:return ""
        }
    }

    getPersonalData() {
        let firstName = this.params.First_name ? this.params.First_name : ""
        let lastName = this.params.Last_name ? this.params.Last_name : ""
        let kids_num = this.params.kids_num ? this.params.kids_num : ""
        let id = this.params.ID_passport ? this.params.ID_passport : ""
        let Marital_status=""
        if (this.params && this.params.Marital_status) {
            Marital_status = this.params.Marital_status === "Single" ? "רווק/ה" : Marital_status
            Marital_status = this.params.Marital_status === "common-law-marriage" ? "ידוע/ה בציבור" : Marital_status
            Marital_status = this.params.Marital_status === "Married" ? "נשוי/אה" : Marital_status
            Marital_status = this.params.Marital_status === "Separeted" ? "פרוד/ה" : Marital_status
            Marital_status = this.params.Marital_status === "Divorced" ? "גרוש/ה" : Marital_status
            Marital_status = this.params.Marital_status === "Widowed" ? "אלמן/נה" : Marital_status
            Marital_status = this.params.Marital_status === "Other" ? "אחר" : Marital_status
        }
        let mail = this.params.Email ? this.params.Email : ""
        let phone = this.params.Phone_num1 ? this.params.Phone_num1 : ""
        let insurance = this.params.Insuring_factor ? this.getInsurace(this.params.Insuring_factor) : ""
        let age = this.getPatientAge()
        return (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-title-block">' +
            '<div dir="rtl" class="pdfFile-details-title-label">פרטים אישיים</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-row">' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">שם מלא</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + firstName + ' ' + lastName + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">תעודת זהות</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + id + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">גיל</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + age + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">קופ״ח</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + insurance + '</div>' +
            '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-row">' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">טלפון</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + phone + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">אימייל</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + mail + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">מצב משפחתי</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Marital_status + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">מספר ילדים</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + kids_num + '</div>' +
            '</div>' +
            '</div>' +
            '</div>'
        )
    }


    getFreeTexts() {
        let todo = "TODO"
        let physical_examination = this.params.physical_examination ? this.params.physical_examination : ""
        let current_Diseases = this.params.Additional_medical_details ? this.params.Additional_medical_details : ""
        let ShowingReason = this.params.ShowingReason ? this.params.ShowingReason : ""
        let ImagingAndHelpfulTests = this.params.ImagingAndHelpfulTests ? this.params.ImagingAndHelpfulTests : ""
        let doctors_referral = this.params.doctors_referral ? this.params.doctors_referral : ""
        ShowingReason=this.replaceAllForNewLine(ShowingReason)
        current_Diseases=this.replaceAllForNewLine(current_Diseases)
        doctors_referral=this.replaceAllForNewLine(doctors_referral)
        physical_examination=this.replaceAllForNewLine(physical_examination)
        ImagingAndHelpfulTests=this.replaceAllForNewLine(ImagingAndHelpfulTests)

        return (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">סיבת הפניה</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + ShowingReason + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">מחלה נוכחית</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + current_Diseases + '</div>' +
            '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">סימפטומים לטיפול</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + this.params.SymptomsText + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">המלצה מרופאים נוספים</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + doctors_referral + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">בדיקה גופנית</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + physical_examination + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">הדמיה ובדיקות עזר</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + ImagingAndHelpfulTests + '</div>' +
            '</div>' +
            '</div>'
        )
    }

    getDiseases() {
        let todo = "TODO"
        let allergy_dye=""
        if (this.params && this.params.allergy_dye) {
            allergy_dye = this.params.allergy_dye === "Yes" ? "כן" : allergy_dye
            allergy_dye = this.params.allergy_dye === "No" ? "לא" : allergy_dye
            allergy_dye = this.params.allergy_dye === "Unknown" ? "לא ידוע" : allergy_dye
        }
        return (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-title-block">' +
            '<div dir="rtl" class="pdfFile-details-title-label">מחלות רקע</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-row">' +
            '<div dir="rtl" class="pdfFile-details-item-double">' +
            '<div dir="rtl" class="pdfFile-details-item-label">מחלות רקע</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + this.params.medConditionText + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">אלרגיה</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + this.params.allergicsText + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">אלרגיה ליוד</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + allergy_dye + '</div>' +
            '</div>' +
            '</div>' +
            '</div>'
        )
    }

    getMedications() {
        let todo = "TODO"
        return (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-title-block">' +
            '<div dir="rtl" class="pdfFile-details-title-label">תרופות</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-row">' +
            '<div dir="rtl" class="pdfFile-details-item-double">' +
            '<div dir="rtl" class="pdfFile-details-item-label">תרופות כאב נוכחיות</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + this.params.painText + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-double">' +
            '<div dir="rtl" class="pdfFile-details-item-label">תרופות כאב  בעבר</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + this.params.pastMedText + '</div>' +
            '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-row">' +
            '<div dir="rtl" class="pdfFile-details-item-double">' +
            '<div dir="rtl" class="pdfFile-details-item-label">תרופות כללי</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + this.params.generalMedicationsText + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-double">' +
            '<div dir="rtl" class="pdfFile-details-item-label">תרופות לדילול הדם</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + this.params.bloodThinnerText + '</div>' +
            '</div>' +
            '</div>' +
            '</div>'
        )
    }

    getLifeStyle() {
        let Smoker = ""
        if (this.params && this.params.Smoker) {
            Smoker = this.params.Smoker === "Yes" ? "כן" : Smoker
            Smoker = this.params.Smoker === "No" ? "לא, אף פעם" : Smoker
            Smoker = this.params.Smoker === "SmokePast" ? "לא, בעבר עישנתי" : Smoker
        }
        let work_type = ""

        if (this.params && this.params.work_type) {
            work_type = this.params.work_type === "work_office" ? "עבודה משרדית" : work_type
            work_type = this.params.work_type === "hand_work" ? "עבודת כפיים" : work_type
            work_type = this.params.work_type === "risk_work" ? "עבודה בסיכון" : work_type
            work_type = this.params.work_type === "security_work" ? "כוחות בטחון והצלה" : work_type
            work_type = this.params.work_type === "drive_work" ? "נהג/ת" : work_type
            work_type = this.params.work_type === "Other" ? this.params.other_work_type : work_type
        }

        let smokedCannabisText = ""

        if (this.params && this.params.Smoked_cannabis) {
            smokedCannabisText = this.params.Smoked_cannabis === "No" ? "לא" : smokedCannabisText
            smokedCannabisText = this.params.Smoked_cannabis === "YesPast" ? "כן, בעבר" : smokedCannabisText
            smokedCannabisText = this.params.Smoked_cannabis === "YesPresent" ? "כן אני משתמש בקנביס בהווה (לפחות פעם בשבוע במהלך החודשיים האחרונים)" : smokedCannabisText
        }
        let Smoked_cannabis_cause = ""

        if (this.params && this.params.Smoked_cannabis_cause) {
            Smoked_cannabis_cause = this.params.Smoked_cannabis_cause === "Recreational" ? " ,פנאי" : Smoked_cannabis_cause
            Smoked_cannabis_cause = this.params.Smoked_cannabis_cause === "Medical" ? " ,רפואי" : Smoked_cannabis_cause
        }
        let Consuming_license = ""

        if (this.params && this.params.Consuming_license) {
            Consuming_license = this.params.Consuming_license === "6M" ? " ,חצי שנה" : Consuming_license
            Consuming_license = this.params.Consuming_license === "6M_1Y" ? " ,חצי שנה - שנה" : Consuming_license
            Consuming_license = this.params.Consuming_license === "1_3Y" ? " ,שנה - 3 שנים" : Consuming_license
            Consuming_license = this.params.Consuming_license === "3_5Y" ? " ,3-5 שנים" : Consuming_license
            Consuming_license = this.params.Consuming_license === "5+Y" ? " ,מעל 5 שנים" : Consuming_license
        }

        let Cannabis_freq_past_year = this.params.Cannabis_freq_past_year ? ", " + this.params.Cannabis_freq_past_year + " גרם" : ""

        let usedType = ""
        usedType = this.params.U_Flower ? usedType + " ,פרח " : usedType
        usedType = this.params.U_Flower_vaping ? usedType + " ,פרח אידוי " : usedType
        usedType = this.params.U_oil ? usedType + " ,שמן " : usedType
        usedType = this.params.U_oil_vaping ? usedType + " ,אידוי שמן " : usedType
        usedType = this.params.U_edibles ? usedType + " ,מאכל " : usedType
        usedType = this.params.U_accurate_dose_tool ? usedType + " ,אמצעי מתן במינון מדויק " : usedType
        usedType = this.params.U_other ? usedType + ", "  + this.params.U_other_text : usedType
        let Smoked_cannabis=""

        if(this.params.Smoked_cannabis !== "No"){
            Smoked_cannabis = smokedCannabisText + Smoked_cannabis_cause + Consuming_license + Cannabis_freq_past_year + usedType
        }else{
            Smoked_cannabis = smokedCannabisText
        }
        let past_use = this.params.cannabis_patient ? ('<div dir="rtl" class="pdfFile-details-item-double">' +
            '<div dir="rtl" class="pdfFile-details-item-label">ניסיון קודם בקנביס</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Smoked_cannabis + '</div>' +
            '</div>') : ''
        return (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-title-block">' +
            '<div dir="rtl" class="pdfFile-details-title-label">הרגלים</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-row">' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">עישון</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Smoker + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item">' +
            '<div dir="rtl" class="pdfFile-details-item-label">מקצוע</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + work_type + '</div>' +
            '</div>' +
            past_use +
            '</div>' +
            '</div>'
        )
    }

    replaceAllForNewLine(obj){
        return obj.replaceAll("\n","<br/>")
    }
    getSummaryAndRecommendation() {
        let todo = "TODO"
        let Additional_tests = this.params.Additional_tests ? this.params.Additional_tests : ""
        let Recommended_medications = this.params.Recommended_medications ? this.params.Recommended_medications : ""
        let Recommended_invasive_treatment = this.params.Recommended_invasive_treatment ? this.params.Recommended_invasive_treatment : ""
        let Other_treatment = this.params.Other_treatment ? this.params.Other_treatment : ""
        let Validity_of_prescription = this.params.Validity_of_prescription ? utils.getDateFormatWithYear(new Date(this.params.Validity_of_prescription)) : ""
        let visit_summary = this.params.visit_summary ? this.params.visit_summary : ""

        let validityBlock = this.params.cannabis_patient ? '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">תוקף רישיון קנביס</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Validity_of_prescription + '</div>' +
            '</div>' : ''

        let instructionTextBlock = ''

        if (this.params.instructionText) {
            this.params.instructionText.map(item =>
                instructionTextBlock = instructionTextBlock + '<div dir="rtl" class="pdfFile-details-item-value2">' + item + '</div>'
            )
        }
        let diagnose = this.params.medical_diagnoses_icd_name && this.params.medical_diagnoses_icd_name.label.toLowerCase() !== "other" ?
            this.params.medical_diagnoses_icd_name.label : this.params.other_diagnoses
        let anotherDiagnose = this.params.Another_Medical_diagnoses_icd_name && this.params.Another_Medical_diagnoses_icd_name.label.toLowerCase() !== "other" ?
            ", " + this.params.Another_Medical_diagnoses_icd_name.label : ", " +this.params.another_other_diagnoses


        visit_summary=this.replaceAllForNewLine(visit_summary)
        Additional_tests=this.replaceAllForNewLine(Additional_tests)
        Recommended_medications=this.replaceAllForNewLine(Recommended_medications)
        Recommended_invasive_treatment=this.replaceAllForNewLine(Recommended_invasive_treatment)
        Other_treatment=this.replaceAllForNewLine(Other_treatment)
        return (
            '<div dir="rtl" class="pdfFile-details-block">' +
            '<div dir="rtl" class="pdfFile-details-title-block">' +
            '<div dir="rtl" class="pdfFile-details-title-label">סיכום והמלצות טיפול</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">דיון וסיכום</div>' +
            '<span dir="rtl" class="pdfFile-details-item-value" role="textbox">' + visit_summary + '</span>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">אבחנה</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + diagnose + anotherDiagnose + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">הפניה לבדיקות נוספות</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Additional_tests + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">טיפול תרופתי מומלץ</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Recommended_medications + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">טיפול פולשני מומלץ</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Recommended_invasive_treatment + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">טיפול אחר</div>' +
            '<div dir="rtl" class="pdfFile-details-item-value">' + Other_treatment + '</div>' +
            '</div>' +
            '<div dir="rtl" class="pdfFile-details-item-full">' +
            '<div dir="rtl" class="pdfFile-details-item-label">הנחיות</div>' +
            instructionTextBlock +
            '</div>' +
            validityBlock +

            '</div>'
        )
    }

    isAnalgesic(id) {
        let medicationsList = this.params.medicationsList ? this.params.medicationsList : []
        for (let i = 0; i < medicationsList.length; i++) {
            if (id.toString() === medicationsList[i].Med_ID.toString() && medicationsList[i].Analgesic === "Analgesic") {
                return true
                break;
            }
        }
    }

    isBloodThinner(id) {
        let medicationsList = this.params.medicationsList ? this.params.medicationsList : []
        for (let i = 0; i < medicationsList.length; i++) {
            if (id.toString() === medicationsList[i].Med_ID.toString() && medicationsList[i].BloodThinner === "BloodThinner") {
                return true
                break;
            }
        }
    }

    getVAS(value) {
        switch (value) {
            case "0":
                return "כלל לא"
            case "1":
                return "קל מאוד"
            case "2":
                return "קל"
            case "3":
                return "בינוני"
            case "4":
                return "בינוני-חזק"
            case "5":
                return "חזק"
            case "6":
                return "חזק-חמור"
            case "7":
                return "חמור"
            case "8":
                return "חמור מאוד"
            case "9":
                return "בלתי נסבל"
            case "10":
                return "הכי חזק שניתן לדמיין"
            default:
                return ""
        }
    }

    initHTML() {
        let user = authenticationService.currentUserValue.profile;

        let date = moment().format("DD/MM/YYYY")
        let birthday = this.params.Date_of_birth ? utils.getDateFormatWithYear(new Date(this.params.Date_of_birth)) : ""
        let userStorage = this.params.UserStorageID ? this.params.UserStorageID : ""


        let currentUserProfile = authenticationService.currentUserValue.profile;


        let clinicSVG = renderToString(<img className={'profilePic'} src={this.params.clinicPhoto} width={'150px'}
                                            height={'114px'}
                                            style={{marginTop: '29px', marginRight: '48px'}}/>)

        let morningSVG = renderToString(<SvGraphics className={'svg-pdf'} svgname={'morning-icon-blue'} width={'15px'}
                                                    height={'15px'}/>)
        let eveningSVG = renderToString(<SvGraphics className={'svg-pdf'} svgname={'evening-icon-blue'} width={'15px'}
                                                    height={'15px'}/>)
        let noonSVG = renderToString(<SvGraphics className={'svg-pdf'} svgname={'noon-icon-blue'} width={'15px'}
                                                 height={'15px'}/>)


        let allmedications = ""
        let allAnalgesicmedications = ""
        let allpastmedications = ""
        let medications = this.params.medications ? this.params.medications : []

        for (let i = 0; i < medications.length; i++) {
            if (medications[i].General_Thinner_Past !== "Y") {
                if (medications[i].Med_ID) {
                    if (this.isAnalgesic(medications[i].Med_ID)) {
                        allAnalgesicmedications = medications[i].Medication_name !== "Other" ? allAnalgesicmedications + medications[i].Medication_name + " " : allAnalgesicmedications + medications[i].OtherMed
                    }
                    if (this.isBloodThinner(medications[i].Med_ID)) {
                        allmedications = medications[i].Medication_name !== "Other" ? allmedications + medications[i].Medication_name + " " : allmedications + medications[i].OtherMed
                    }
                }
            } else {
                if (this.isAnalgesic(medications[i].Med_ID)) {
                    allpastmedications = medications[i].Medication_name !== "Other" ? allpastmedications + medications[i].Medication_name + " " : allpastmedications + medications[i].OtherMed
                }
            }
        }

        let allTreatments = ''
        let treatments = this.params.patientTreatments ? this.params.patientTreatments : ""
        let treatmentSteps = ''


        for (let i = 0; i < treatments.length; i++) {
            treatmentSteps = ''
            let treatmentplan = treatments[i].titrationPlan ? treatments[i].titrationPlan : ""
            let intakeMethod = treatments[i].TreatmentIntakeMethod ? treatments[i].TreatmentIntakeMethod : ""
            intakeMethod= intakeMethod==="Flower"?"פרח":intakeMethod
            intakeMethod= intakeMethod==="Oil drops"?"טיפות שמן":intakeMethod
            intakeMethod= intakeMethod==="Precision Dosing Devices"?"משאף למינון מדוד":intakeMethod
            intakeMethod= intakeMethod==="Other"?"אחר":intakeMethod
            let varity = treatments[i].TreatmentVariety ? treatments[i].TreatmentVariety : ""
            varity = varity === "Select All" ? "סאטיבה, זן היברידי, אינדיקה" : varity
            varity = varity === "Sativa" ? "סאטיבה" : varity
            varity = varity === "Blend" ? "זן היברידי" : varity
            varity = varity === "Indica" ? "אינדיקה" : varity

            let category = treatments[i].TreatmentCategory ? treatments[i].TreatmentCategory : ""
            let TreatmentMonthlyDosage = treatments[i].TreatmentMonthlyDosage ? treatments[i].TreatmentMonthlyDosage : ""
            TreatmentMonthlyDosage = TreatmentMonthlyDosage !== "Other" ? TreatmentMonthlyDosage : treatments[i].TreatmentMonthlyDosageOther

            let monthlyDosage = TreatmentMonthlyDosage !== "" ? '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">מינון חודשי (גרם)</div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + TreatmentMonthlyDosage + '</div>' +
                '</div>' : ''

            let TreatmentInitialDose = treatments[i].TreatmentInitialDose ? treatments[i].TreatmentInitialDose : ""

            let initialDose = TreatmentInitialDose !== "" ? '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">מינון התחלתי (שאיפות/טיפות)</div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + TreatmentInitialDose + '</div>' +
                '</div>' : ''
            let Treatment_Maximum_dosage = treatments[i].Treatment_Maximum_dosage ? treatments[i].Treatment_Maximum_dosage : ""

            let maximumDosage = Treatment_Maximum_dosage !== "" ? '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">מינון מקסימלי (שאיפות/טיפות)</div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + Treatment_Maximum_dosage + '</div>' +
                '</div>' : ''
            let TreatmentStepUpEvery = treatments[i].TreatmentStepUpEvery ? treatments[i].TreatmentStepUpEvery : ""

            let stepUpEvery = TreatmentStepUpEvery !== "" ? '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">קצב העלאת מינון (ימים)</div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + TreatmentStepUpEvery + '</div>' +
                '</div>' : ''
            let stepupEvery = parseInt(treatments[i].TreatmentStepUpEvery)
            let currentIndex = 1
            let currentStepIndex = 0
            if (treatmentplan) {
                for (let j = 0; j < treatmentplan.length; j++) {

                    if (currentStepIndex % 4 === 0 && currentStepIndex !== 0) {
                        treatmentSteps = treatmentSteps + '</div>' + '<div class="treatment-step-row">'
                    } else if (currentStepIndex === 0) {
                        treatmentSteps = treatmentSteps + '<div class="treatment-step-row">'
                    }

                    treatmentSteps = treatmentSteps +
                        '<div dir="rtl" class="treatment-step-block">' +

                        '<div class="step-index-day">' +
                        '<div class="step-index-block">' +
                        '<div class="step-index-label">' + (j + 1) + '</div>' +
                        '</div>' +
                        '<div class="step-days">ימים ' + (currentIndex + stepupEvery - 1) + "-" + (currentIndex) +
                        '</div>' +
                        '</div>' +

                        '<div class="treatment-steps-daily">' +
                        '<div class="treatment-step-daily">' +
                        '<div class="treatmentSVGBlock">' + `${morningSVG}` + '</div>' +
                        '<div class="step-index-number">' + treatmentplan[j].M + '</div>' +
                        '</div>' +

                        '<div class="treatment-step-daily">' +
                        '<div class="treatmentSVGBlock">' + `${noonSVG}` + '</div>' +
                        '<div class="step-index-number">' + treatmentplan[j].N + '</div>' +
                        '</div>' +

                        '<div class="treatment-step-daily">' +
                        '<div class="treatmentSVGBlock">' + `${eveningSVG}` + '</div>' +
                        '<div class="step-index-number">' + treatmentplan[j].E + '</div>' +
                        '</div>' +


                        '</div>' +
                        '</div>'
                    currentStepIndex = currentStepIndex + 1
                    if (currentStepIndex === treatmentplan.length && currentStepIndex % 4 !== 0) {
                        let toAdd = (4-((currentStepIndex) % 4))
                        for (let b = 0; b < toAdd; b++) {
                            treatmentSteps = treatmentSteps + '<div dir="rtl" class="treatment-step-block-empty">' + '</div>'
                        }
                    }
                    currentIndex = currentIndex + stepupEvery
                }
                treatmentSteps = treatmentSteps ? treatmentSteps + '</div>' : ""
            }

            let symptomsArr =treatments[i].symptomsArr
            let symptomsText=""
            for(let j=0;j<symptomsArr.length;j++){
                if(symptomsArr[j]){
                    symptomsText=symptomsText===""? symptomsArr[j]:symptomsText+", "+ symptomsArr[j]
                }
            }
            allTreatments = allTreatments +
                '<div dir="rtl" class="pdfFile-details-block">' +
                '<div dir="rtl" class="pdfFile-details-title-block">' +
                '<div dir="rtl" class="pdfFile-details-title-label">תכנית טיפול קנביס - מוצר' + " " + (i + 1) + '</div>' +
                '</div>' +
                '<div dir="rtl" class="pdfFile-details-row">' +
                '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">תלונה </div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + symptomsText + '</div>' +
                '</div>' +
                '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">אמצעי מתן </div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + intakeMethod + '</div>' +
                '</div>' +
                '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">זן</div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + varity + '</div>' +
                '</div>' +
                '<div dir="rtl" class="pdfFile-details-item">' +
                '<div dir="rtl" class="pdfFile-details-item-label">קטגוריה</div>' +
                '<div dir="rtl" class="pdfFile-details-item-value">' + category + '</div>' +
                '</div>' +
                '</div>' +

                '<div dir="rtl" class="pdfFile-details-row">' +
                monthlyDosage +
                initialDose +
                maximumDosage +
                stepUpEvery +
                '</div>' +
                '<div class="treatment-steps">' +
                treatmentSteps +
                '</div>' +

                '<div dir="rtl" class="pdfFile-treatment-block-sentence">' +
                '<div dir="rtl" class="pdfFile-treatment-sentence">יש להיצמד לתוכנית הטיפול- להתחיל במינון ההתחלתי ולהעלות כל 3 ימים עד למינון שבו יש יעילות אך אין</div>' +
                '<div dir="rtl" class="pdfFile-treatment-sentence">תופעות לוואי משמעותיות. אין לעבור את המינון היומי המקסימלי.</div>' +
                '</div>' +
                '</div>'

        }

        allTreatments = this.params.cannabis_patient ? allTreatments : ""

        let doctorSignature = this.params.doctorSignature ? this.params.doctorSignature : ""
        let doctorName = this.params.doctorName ? this.params.doctorName : ""
        let clinicName = currentUserProfile.Doctor?.Clinic?.clinicName ? currentUserProfile.Doctor.Clinic.clinicName : ""
        let clinicAddress = currentUserProfile.Doctor?.Clinic?.Clinic_Address ? currentUserProfile.Doctor.Clinic.Clinic_Address : ""
        let Clinic_Info = currentUserProfile.Doctor?.Clinic?.Clinic_Info ? currentUserProfile.Doctor.Clinic.Clinic_Info : ""

        let headerBlock = ('<div dir="rtl" class="header_block">'
            + `${clinicSVG}` +
            '<div dir="rtl" class="doctorInfo">' +
            '<textarea class="doctor-info-label">' + doctorSignature + '</textarea>' +
            '</div>' +
            '<div dir="rtl" class="clinic-Info">' +
            '<textarea class="clinic-adress-label">' + clinicAddress + '</textarea>' +
            '<textarea class="clinic-info-label">' + Clinic_Info + '</textarea>' +
            '</div>' +
            '</div>')

        return (

            '<html>' +
            '<head><title>' + userStorage + ' Visit Summary</title>' +
            '<style>' +
            '  @import url(\'https://fonts.googleapis.com/css2?family=Assistant:wght@300&display=swap\');' +
            '  @import url(\'https://fonts.googleapis.com/css2?family=Assistant:wght@600&display=swap\');' +
            '  @import url(\'https://fonts.googleapis.com/css2?family=Assistant:wght@200&display=swap\');' +
            ' .pdf-Body {margin:0;zoom: 100%;max-width: 1000px;}' +
            ' .white-svg2 {fill:#ffffff;}' +
            ' .white-svg {fill:#ffffff;margin-top: 6px;z-index:99!important;}' +
            ' .svg-sentence {display: flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .footer_item1 {margin: 26px 47.8px 25px 0;}' +
            ' .footer_item2 {margin: 26px 134.2px 25px 0;}' +
            ' .footer_item3 {margin: 26px 155px 25px 0;}' +
            ' .footer_item4 {margin: 26px 17.7px 25px 0;}' +
            ' .footer_item_sentence2 {min-height: 18px;margin: 2px 6.7px 0 21px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 600;font-stretch: normal;font-style: normal;line-height: 1.64;letter-spacing: 0.35px;text-align: right;color: #ffffff;}' +
            ' .footer_item_sentence {min-height: 18px;margin: 0 0.8px 2px 0;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.64;letter-spacing: 0.35px;text-align: right;color: #ffffff;}' +
            ' .footer_item_sentence_bold {min-height: 19px;min-width:210px;font-family: Assistant, sans-serif;font-size: 15px;font-weight: 600;font-stretch: normal;font-style: normal;line-height: 1.33;letter-spacing: normal;text-align: right;color: #ffffff;}' +
            ' .header_block{width: 1000px;min-height: 173px;margin: 0 48px 31px 0;object-fit: contain;background-color: #f6f6f6;display: flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .footer_block{ page-break-inside:avoid;z-index: -1;display:flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;width: 1000px;height: 89px;margin: 40px 0 0;object-fit: contain;background-color: #005f7f;}' +
            ' .doctorInfo{min-width: 157px;height: 56px;margin: 50px 20px 37px 67px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.36;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .doctor-info-label{width:100%;height:103px;font-size: 14px;font-weight: 300;;font-family: Assistant, sans-serif;background-color: #f6f6f6;font-stretch: normal;font-style: normal;line-height: 1.36;text-align: right;color: #1d1d1b;resize: none;border: 0;}' +
            ' .clinic-Info{display:flex;width: 462px;padding-top: 12px;height: 103px;margin: 35px 45px 5px 0;object-fit: contain;border-radius: 10px;background-color: #ffffff;}' +
            ' .clinic-adress-label{width: 45%;height:103px;margin: 0 30px 16px 0;border:0;resize:none;font-family: Assistant,sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.36;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .clinic-info-label{width: 45%;min-height: 100%;resize:none;border:0;margin: 0 30px 16px 0px;font-family: Assistant,sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.36;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .file-title-div{display:flex;margin:30px 47px 0 665px}' +
            ' .pdfFile-signature_line{width: 396px;min-height: 1px;margin: 60px 10px 4px 0;object-fit: contain;background-color: #d2cccc;}' +
            ' .pdfFile-signature-doctorName{min-width:171px;min-height: 23px;margin: 40px 27px 2px 287px;font-family: Assistant, sans-serif;font-size: 18px;font-weight: 600;font-stretch: normal;font-style: normal;line-height: 1.33;letter-spacing: 0.45px;text-align: right;color: #005f7f; }' +
            ' .pdfFile-signature{min-height: 23px;margin: 40px 0 2px 0px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 600;font-stretch: normal;font-style: normal;line-height: 1.71;letter-spacing: 0.35px;text-align: right;color: #1d1d1b; }' +
            ' .file-title-label{min-height: 28px;margin: 0 0 0 20px;font-family: Assistant, sans-serif;font-size: 22px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: 1.73;letter-spacing: 0.55px;text-align: right;color: #005f7f;}' +
            ' .file-title-date{width: 104px;min-height: 28px;font-family: Assistant, sans-serif;font-size: 22px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.73;letter-spacing: 0.55px;text-align: right;color: #005f7f;}' +
            ' .pdfFile-details-block{page-break-inside:avoid;width:906px;min-height:103px;margin: 24px 47px 0 47px; padding: 0 0 25px;object-fit:contain;border-radius: 10px;  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);  background-color: #ffffff;}' +
            ' .pdfFile-details-block-sentence{page-break-inside:avoid;width:906px;min-height:25px;margin: 21px 47px 0 47px;object-fit:contain;background-color: #ffffff;}' +
            ' .pdfFile-details-block-signature{page-break-inside:avoid;width:906px;min-height:25px;margin: 21px 47px 0 47px;object-fit:contain;background-color: #ffffff;display: flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-details-title-block{ border-radius:10px 10px 0 0;padding: 8px 34px 7px 0;object-fit: contain;background-color: #f6f6f6;}' +
            ' .pdfFile-details-title-label{min-height: 18px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: 1.57;letter-spacing: 0.35px;text-align: right;color: #005f7f;}' +
            ' .pdfFile-details-row{display: flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-Instruction-items{display: flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-Instruction-point{width: 6px;height: 6px;margin: 7px 0 16px 9px;object-fit: contain;background-color: #005f7f;border-radius: 50%;}' +
            ' .pdfFile-Instruction-subpoint{width: 5px;height: 5px;margin: 7px 10px 6px 9px;object-fit: contain;border: solid 0.5px #005f7f;;border-radius: 50%;}' +
            ' .pdfFile-Instruction-sentence{height: 18px;width: 90%;margin: 0 9px 11px 20px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.40;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-Instruction-sentence2{height: 40px;width: 90%;margin: 0 9px 11px 20px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.40;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-Instruction-sentence3{height: 50px;width: 90%;margin: 0 9px 11px 20px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.40;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-Instruction-Block{margin: 15px 0 10px 0;}' +
            ' .pdfFile-details-item{page-break-inside:avoid!important;width: 22%;padding: 27px 35px 4px 0;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-details-item-double{page-break-inside:avoid!important;width: 47%;padding: 27px 35px 4px 0;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-details-item-full{page-break-inside:avoid!important;padding: 27px 35px 4px 0;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .pdfFile-details-item-label{min-height: 18px;margin: 0 0 4px 0;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 600;font-stretch: normal;font-style: normal;line-height: 2.64;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-details-item-value{overflow-wrap: break-word;min-height: 23px;margin: 4px 1px 0 0;font-family: Assistant, sans-serif;font-size: 18px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 2.17;letter-spacing: 0.45px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-details-item-value-textarea{resize: none;border: 0;width:100%!important;height:100%;overflow-wrap: break-word;margin: 4px 1px 0 0;font-family: Assistant, sans-serif;font-size: 18px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 2.17;letter-spacing: 0.45px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-details-item-value-textarea2{ display: block; + width: 100%;overflow: hidden;resize: both;min-height: 40px;line-height: 20px;}'+
            ' .pdfFile-details-item-value2{overflow-wrap: break-word;min-height: 23px;margin: 4px 1px 0 0;font-family: Assistant, sans-serif;font-size: 18px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.43;letter-spacing: 0.45px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-thanks-sentence{min-height: 23px;float:right;margin-right: 27px;font-family: Assistant, sans-serif;font-size: 18px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.39;letter-spacing: 0.45px;text-align: right;color: #1d1d1b;}' +
            ' .pdfFile-treatment-block-sentence{page-break-inside:avoid;width:906px;min-height:25px;margin: 21px 35px 0 47px;object-fit:contain;background-color: #ffffff;}' +
            ' .pdfFile-treatment-sentence{width:100%;min-height: 23px;float:right;font-family: Assistant, sans-serif;font-size: 13px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.43;letter-spacing: 0.35px;text-align: right;color: #1d1d1b;}' +
            ' .treatment-steps {margin: 20px 35px 0px 35px;display: flex;flex-wrap: wrap;}' +
            ' .treatment-step-row {margin: 20px 35px 0px 35px;display: flex;display: -webkit-box}' +
            ' .step-index-day {display:flex;display: -webkit-box;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .step-index-block {width: 23px;min-height: 22px;max-height: 22px;margin: 9px 11px 11px 35px;/*padding: 1px 8px 3px 9px;*/object-fit: contain;background-color: #f6f6f6;border-radius:50%;}' +
            ' .step-index-label {margin-right: 7px;width: 6px;min-height: 18px;font-family: Assistant, sans-serif;font-size: 14px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 1.64;letter-spacing: 0.35px;text-align: right;color: #005f7f;}' +
            ' .treatment-step-block {width: 192px;max-width: 192px;height: 124px;margin: 10px 0 0 15px;/*padding: 11px 11px 15px 37px;*/object-fit: contain;border-radius: 10px;border: solid 1px #e8e8e8;background-color: #ffffff;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .treatment-step-block-empty {width: 192px;height: 124px;margin: 10px 0 0 15px;/*padding: 11px 11px 15px 37px;*/object-fit: contain;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .step-days {height: 23px;margin: 0 0 13px 33px;font-family: Assistant, sans-serif;font-size: 18px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 2.17;letter-spacing: 0.45px;text-align: center;color: #1d1d1b;}' +
            ' .treatment-steps-daily {margin-right:5px;min-width: 190px;max-width: 190px;margin-top: 10px;justify-content: space-evenly;display: -webkit-box;display:flex;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .treatment-step-daily {width: 37px;max-width: 37px;min-height: 63px;margin: 0 0 0 7px;object-fit: contain;border-radius: 6px;border: solid 1px #005f7f;background-color: #fafafa;-webkit-box-flex: 1;-webkit-flex: 1;}' +
            ' .treatmentSVGBlock {width:15px;max-width:15px;padding:10px;height: 10px;border: 1px solid #005f7f;border-radius:6px 6px 0 0}' +
            ' .step-index-number {padding:4px;height: 23px;font-size: 14px;border-radius: 0 0 6px 6px;background-color: #005f7f;text-align: center;color: #ffffff;font-family: Assistant, sans-serif;line-height: 1.43;letter-spacing: 0.35px;font-weight: bold;font-stretch: normal;font-style: normal;}' +


            ' .label-pdfFile_title {color: #1d1d1b;padding: 0 15px 0 0;min-width: 11%;font-family: Assistant, sans-serif;font-size: 11px;font-weight: 300;font-stretch: normal;font-style: normal;line-height: 2.18;letter-spacing: 0.28px;text-align: right;}' +
            ' .label-pdfFile {word-wrap: break-word;margin: 0 0 0 12px;padding: 0 15px 0 0;font-family: Assistant, sans-serif;font-size: 11px;font-weight: 600;font-stretch: normal;font-style: normal;line-height: 1.09;letter-spacing: 0.55px;text-align: right;color: #1d1d1b;}' +
            ' .div-pdfFile-row {display:flex;margin-bottom:20px;}' +
            ' .row-input {display:block;min-width: 27.5%;max-width: 27.5%}' +
            '</style>' +
            '</head><body class="pdf-Body" id="pdf-Body">' +
            headerBlock +
            '<div dir="rtl" class="file-title-div">' +
            '<label class="file-title-label">סיכום ביקור</label>' +
            '<label class="file-title-date">' + date + '</label>' +
            '</div>' +

            this.getPersonalData() +


            '<div dir="rtl" class="pdfFile-details-block-sentence" id="pdf-Body-test">' +
            '<div dir="rtl" class="pdfFile-thanks-sentence">תודה על הפניית המטופל/ת</div>' +
            '</div>' +

            this.getFreeTexts() +

            this.getDiseases() +

            this.getMedications() +

            this.getLifeStyle() +

            this.getSummaryAndRecommendation() +


            allTreatments +

            '<div dir="rtl" class="pdfFile-details-block-sentence">' +
            '<div dir="rtl" class="pdfFile-thanks-sentence">תודה שוב על הפנית המטופל/ת למרפאתי. אמשיך לעדכן אותך על מצב המטופל/ת.' + '</div>' +
            '<div dir="rtl" class="pdfFile-thanks-sentence">במידה והינך מעוניין במידע נוסף אשמח לספק פרטים נוספים.' + '</div>' +
            '</div>' +

            '<div dir="rtl" class="pdfFile-details-block-signature">' +
            '<div dir="rtl" class="pdfFile-signature-doctorName">' + doctorName
            + '</div>' +
            '<div dir="rtl" class="pdfFile-signature">חתימה</div>' +
            '<div dir="rtl" class="pdfFile-signature_line"></div>' +
            '</div>' +

            this.getSummaryFooter() +

            this.getInstructions() +

            '</div>' +
            '</body></html>')

    }
}

